// extracted by mini-css-extract-plugin
export default {"container":"V4bVa","description":"Kdxl5","tablet":"nOv3l"};